import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { CtaSection } from '../components/sections/CtaSection';
import { CalendarIcon, DownloadIcon, SunIcon, MoonIcon, UsersIcon } from 'lucide-react';
export function SampleAgenda() {
  const [activeDuration, setActiveDuration] = useState(4);
  const [activeDay, setActiveDay] = useState(1);
  const agendaData = {
    3: {
      1: [{
        time: '12:00 PM',
        title: 'VIP Arrivals',
        description: 'Private check-in experience with welcome amenities'
      }, {
        time: '2:00 PM',
        title: 'Welcome Smoothie Bar',
        description: 'Refreshing beverages and light snacks'
      }, {
        time: '3:00 PM',
        title: 'Executive Pre-Conference',
        description: 'Leadership alignment session'
      }, {
        time: '6:00 PM',
        title: 'Sunset Pier Reception',
        description: 'Icebreakers and networking'
      }, {
        time: '8:00 PM',
        title: 'CEO Welcome Dinner',
        description: 'Casual beachside dining experience'
      }],
      2: [{
        time: '7:00 AM',
        title: 'Sunrise Yoga',
        description: 'Optional wellness activity'
      }, {
        time: '8:00 AM',
        title: 'Breakout Breakfasts',
        description: 'Team discussions over breakfast'
      }, {
        time: '9:30 AM',
        title: 'Strategy Sprint',
        description: 'Facilitated planning session'
      }, {
        time: '12:30 PM',
        title: 'Lunch & Learn',
        description: 'Expert speaker presentation'
      }, {
        time: '2:00 PM',
        title: 'Team Building',
        description: 'Beach Olympics with prizes'
      }, {
        time: '7:00 PM',
        title: 'Awards Dinner',
        description: 'Recognition ceremony with entertainment'
      }],
      3: [{
        time: '8:00 AM',
        title: 'Farewell Breakfast',
        description: 'Group breakfast and closing remarks'
      }, {
        time: '10:00 AM',
        title: 'Check-out',
        description: 'Assisted departure process'
      }, {
        time: '11:00 AM',
        title: 'Private Transfers',
        description: 'Transportation to airport'
      }]
    },
    4: {
      1: [{
        time: '12:00 PM',
        title: 'VIP Arrivals',
        description: 'Private check-in experience with welcome amenities'
      }, {
        time: '2:00 PM',
        title: 'Welcome Smoothie Bar',
        description: 'Refreshing beverages and light snacks'
      }, {
        time: '3:00 PM',
        title: 'Executive Pre-Conference',
        description: 'Leadership alignment session'
      }, {
        time: '6:00 PM',
        title: 'Sunset Pier Reception',
        description: 'Icebreakers and networking'
      }, {
        time: '8:00 PM',
        title: 'CEO Welcome Dinner',
        description: 'Casual beachside dining experience'
      }],
      2: [{
        time: '7:00 AM',
        title: 'Sunrise Yoga',
        description: 'Optional wellness activity'
      }, {
        time: '8:00 AM',
        title: 'Breakout Breakfasts',
        description: 'Team discussions over breakfast'
      }, {
        time: '9:30 AM',
        title: 'Strategy Sprint',
        description: 'Facilitated planning session'
      }, {
        time: '12:30 PM',
        title: 'Lunch & Learn',
        description: 'Expert speaker presentation'
      }, {
        time: '2:00 PM',
        title: 'Team Building',
        description: 'Beach Olympics with prizes'
      }, {
        time: '7:00 PM',
        title: 'Awards Dinner',
        description: 'Recognition ceremony with entertainment'
      }],
      3: [{
        time: '8:00 AM',
        title: 'Group Activities',
        description: 'Various team building exercises'
      }, {
        time: '2:00 PM',
        title: 'Strategy Sessions',
        description: 'Department breakouts and planning'
      }, {
        time: '7:00 PM',
        title: 'Beach Dinner',
        description: 'Casual networking event'
      }],
      4: [{
        time: '8:00 AM',
        title: 'Farewell Breakfast',
        description: 'Group breakfast and closing remarks'
      }, {
        time: '10:00 AM',
        title: 'Check-out',
        description: 'Assisted departure process'
      }, {
        time: '11:00 AM',
        title: 'Private Transfers',
        description: 'Transportation to airport'
      }]
    },
    5: {
      1: [{
        time: '12:00 PM',
        title: 'VIP Arrivals',
        description: 'Private check-in experience with welcome amenities'
      }, {
        time: '2:00 PM',
        title: 'Welcome Smoothie Bar',
        description: 'Refreshing beverages and light snacks'
      }, {
        time: '3:00 PM',
        title: 'Executive Pre-Conference',
        description: 'Leadership alignment session'
      }, {
        time: '6:00 PM',
        title: 'Sunset Pier Reception',
        description: 'Icebreakers and networking'
      }, {
        time: '8:00 PM',
        title: 'CEO Welcome Dinner',
        description: 'Casual beachside dining experience'
      }],
      2: [{
        time: '7:00 AM',
        title: 'Sunrise Yoga',
        description: 'Optional wellness activity'
      }, {
        time: '8:00 AM',
        title: 'Breakout Breakfasts',
        description: 'Team discussions over breakfast'
      }, {
        time: '9:30 AM',
        title: 'Strategy Sprint',
        description: 'Facilitated planning session'
      }, {
        time: '12:30 PM',
        title: 'Lunch & Learn',
        description: 'Expert speaker presentation'
      }, {
        time: '2:00 PM',
        title: 'Team Building',
        description: 'Beach Olympics with prizes'
      }, {
        time: '7:00 PM',
        title: 'Awards Dinner',
        description: 'Recognition ceremony with entertainment'
      }],
      3: [{
        time: '8:00 AM',
        title: 'Group Activities',
        description: 'Various team building exercises'
      }, {
        time: '2:00 PM',
        title: 'Strategy Sessions',
        description: 'Department breakouts and planning'
      }, {
        time: '7:00 PM',
        title: 'Beach Dinner',
        description: 'Casual networking event'
      }],
      4: [{
        time: '8:00 AM',
        title: 'Leadership Workshop',
        description: 'Executive planning session'
      }, {
        time: '2:00 PM',
        title: 'Team Presentations',
        description: 'Group sharing and feedback'
      }, {
        time: '7:00 PM',
        title: 'Gala Dinner',
        description: 'Formal closing celebration'
      }],
      5: [{
        time: '8:00 AM',
        title: 'Farewell Breakfast',
        description: 'Group breakfast and closing remarks'
      }, {
        time: '10:00 AM',
        title: 'Check-out',
        description: 'Assisted departure process'
      }, {
        time: '11:00 AM',
        title: 'Private Transfers',
        description: 'Transportation to airport'
      }]
    }
  };
  return <div className="pt-20 bg-[#F4E8D0]/30" data-id="element-1519">
      {/* Hero */}
      <section className="bg-[#0099A1] py-20" data-id="element-1520">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1521">
          <div className="max-w-3xl" data-id="element-1522">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-1523">
              Sample Agenda
            </h1>
            <p className="text-xl text-white/90" data-id="element-1524">
              Explore our most popular retreat format, customizable to your
              specific objectives.
            </p>
          </div>
        </div>
      </section>
      {/* Agenda Selector */}
      <section className="py-16 bg-white" data-id="element-1525">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1526">
          <div className="mb-12" data-id="element-1527">
            <h2 className="text-3xl font-bold text-[#374047] mb-6" data-id="element-1528">
              Customize Your Experience
            </h2>
            <div className="bg-[#F4E8D0]/50 rounded-xl p-6" data-id="element-1529">
              <div className="mb-6" data-id="element-1530">
                <label className="block text-[#374047] font-medium mb-2" data-id="element-1531">
                  Duration
                </label>
                <div className="flex flex-wrap gap-3" data-id="element-1532">
                  {[3, 4, 5].map(days => <button key={days} onClick={() => {
                  setActiveDuration(days);
                  setActiveDay(1);
                }} className={`px-4 py-2 rounded-md transition-colors ${activeDuration === days ? 'bg-[#0099A1] text-white' : 'bg-white text-[#374047] hover:bg-[#0099A1]/10'}`} data-id="element-1533">
                      {days}-Day Retreat
                    </button>)}
                </div>
              </div>
              <div data-id="element-1534">
                <label className="block text-[#374047] font-medium mb-2" data-id="element-1535">
                  Day
                </label>
                <div className="flex flex-wrap gap-3" data-id="element-1536">
                  {Array.from({
                  length: activeDuration
                }, (_, i) => i + 1).map(day => <button key={day} onClick={() => setActiveDay(day)} className={`px-4 py-2 rounded-md transition-colors ${activeDay === day ? 'bg-[#FF6B65] text-white' : 'bg-white text-[#374047] hover:bg-[#FF6B65]/10'}`} data-id="element-1537">
                      Day {day}
                    </button>)}
                </div>
              </div>
            </div>
          </div>
          {/* Timeline */}
          <Card className="p-6" data-id="element-1538">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4" data-id="element-1539">
              <h3 className="text-2xl font-bold text-[#374047]" data-id="element-1540">
                Day {activeDay} Schedule
              </h3>
              <Button variant="outline" className="flex items-center" data-id="element-1541">
                <DownloadIcon className="h-5 w-5 mr-2" data-id="element-1542" />
                Download PDF Agenda
              </Button>
            </div>
            <div className="relative" data-id="element-1543">
              {/* Timeline Line */}
              <div className="absolute top-0 bottom-0 left-16 md:left-24 w-0.5 bg-[#0099A1]/20" data-id="element-1544"></div>
              <div className="space-y-8" data-id="element-1545">
                {agendaData[activeDuration][activeDay].map((item, index) => <div key={index} className="relative flex" data-id="element-1546">
                    <div className="flex-shrink-0 w-16 md:w-24 pt-1 text-right pr-6" data-id="element-1547">
                      <span className="text-sm font-medium text-[#374047]/70" data-id="element-1548">
                        {item.time}
                      </span>
                    </div>
                    <div className="absolute left-16 md:left-24 -translate-x-1/2 w-4 h-4 rounded-full bg-[#0099A1] border-4 border-white" data-id="element-1549"></div>
                    <div className="flex-grow pl-8" data-id="element-1550">
                      <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100" data-id="element-1551">
                        <h4 className="text-lg font-semibold text-[#374047]" data-id="element-1552">
                          {item.title}
                        </h4>
                        <p className="text-[#374047]/70" data-id="element-1553">{item.description}</p>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </Card>
          <div className="mt-12 text-center" data-id="element-1554">
            <p className="text-lg text-[#374047]/70 mb-6" data-id="element-1555">
              This agenda is fully customizable to meet your organization's
              specific goals and preferences.
            </p>
            <Button variant="primary" size="lg" to="/contact" data-id="element-1556">
              <CalendarIcon className="h-5 w-5 mr-2" data-id="element-1557" />
              Book a Discovery Call
            </Button>
          </div>
        </div>
      </section>
      <CtaSection data-id="element-1558" />
    </div>;
}